<template>
  <div class="quotation-supplier-name-status" :class="{'outside-plugin': outsidePlugin}">
    <span class="detail-title" :class="{'largeSize': outsidePlugin}">{{ info.tenantName }}</span>
    <span v-show="haveStatus" class="status" :class="getStatusColor()">{{ getStatusLabel() }}</span>
    <!-- 议价中 -->
    <el-tooltip v-show="info.status === 'NEGOTIATING' && haveStatus" :content="info.negotiatingType === 'UPDATE' ? '已修改报价，请等待供应商确认' : info.negotiatingType === 'ROLLBACK' ? '本轮报价已回退，请等待供应商新一轮报价' : '--'" placement="bottom-start">
      <img :src="require('@/assets/imgs/icon_tip.svg')" style="margin-right: 10px;" />
    </el-tooltip>
    <!-- 已拒单 -->
    <el-tooltip v-show="info.status === 'REJECTED' && haveStatus" :content="`拒单原因：${info.rejectTypeDesc}`" placement="bottom-start">
      <img :src="require('@/assets/imgs/icon_tip.svg')" style="margin-right: 10px;" />
    </el-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    haveStatus: {
      type: Boolean,
      default: true,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    outsidePlugin: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getStatusLabel () {
      const exp = ['NEGOTIATING', 'CLOSED'];
      if (this.info.status && !exp.includes(this.info.status)) {
        return `供应商${this.info.statusDesc}`;
      }
      return this.info.statusDesc || '--';
    },
    getStatusColor () {
      const blue = ['NEGOTIATING'];
      const green = ['QUOTED', 'ENTERED'];
      const orange = ['WAIT_TASK_ORDER', 'WAIT_QUOTE_PRICE'];
      const grey = ['CLOSED'];
      const red = ['REJECTED'];

      if (blue.includes(this.info.status)) return 'blue';
      if (green.includes(this.info.status)) return 'green';
      if (orange.includes(this.info.status)) return 'orange';
      if (grey.includes(this.info.status)) return 'grey';
      if (red.includes(this.info.status)) return 'red';
      return 'grey';
    },
  },
};
</script>
<style lang="scss" scoped>
.quotation-supplier-name-status {
  width: 80%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  &.outside-plugin {
    padding: 10px;
    padding-left: 5px;
    margin: 0 4px;
  }
  .detail-title {
    font-weight: bold;
    font-size: 14px;
    color: #111111;
    overflow: hidden;
    // max-width: 65%;
    max-width: 70%;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.largeSize {
      font-size: 16px;
    }
  }
  .status {
    flex-shrink: 0;
    font-size: 12px;
    padding: 0 4px;
    height: 22px;
    line-height: 22px;
    margin: 0 4px;
    &.red {
      color: #FF5959;
      background-color: #FFEEEF;
    }
    &.green {
      color: #67C23A;
      background: #F1F8EC;
    }
    &.blue {
      color: #0091FF;
      background: #E5F4FF;
    }
    &.orange {
      color: #E6A23C;
      background: #FDF6EC;
    }
    &.grey {
      color: #909399;
      background: #F0F2F5;
    }
  }
}
</style>
